import { render, staticRenderFns } from "./appTitle.vue?vue&type=template&id=18272e6e&scoped=true&"
import script from "./appTitle.vue?vue&type=script&lang=js&"
export * from "./appTitle.vue?vue&type=script&lang=js&"
import style0 from "./appTitle.vue?vue&type=style&index=0&id=18272e6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18272e6e",
  null
  
)

export default component.exports